import { createSlice } from "@reduxjs/toolkit";

export interface LobType {
  id: number;
  is_active: boolean;
  updated_at: string;
  lob_name: string;
  display_name: string;
  created_at: string;
}

export interface MasterState {
  userData: Array<{ id: number; name: string; email: string }>;
  lobList: LobType[];
  lobOptions: Array<{ value: string; label: string }>;
  memberList: any[];
  memberOptions: Array<{ value: string; label: string }>;
}

const initialState: MasterState = {
  userData: [],
  lobList: [],
  lobOptions: [],
  memberList: [],
  memberOptions: [],
};

const masterSlice = createSlice({
  name: "masterSlice",
  initialState,
  reducers: {
    userData: (state, action) => {
      state.userData = action.payload;
    },
    setLobList: (state, action: { payload: LobType[] }) => {
      state.lobList = action.payload;
      state.lobOptions = action.payload.map((lob) => ({
        value: String(lob.id),
        label: lob.display_name,
      }));
    },
    setMemberList: (state, action: { payload: any }) => {
      const members = Array.isArray(action.payload)
        ? action.payload
        : Array.isArray(action.payload?.results)
          ? action.payload.results
          : Array.isArray(action.payload?.data)
            ? action.payload.data
            : [];

      state.memberList = members;
      state.memberOptions = members.map((member) => ({
        value: String(member.id),
        label:
          member?.employee?.full_name ||
          member?.employee?.email ||
          member?.full_name ||
          member?.email ||
          "Unknown",
      }));
    },
  },
});

export const { userData, setLobList, setMemberList } = masterSlice.actions;
export default masterSlice.reducer;
